import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = createStateReducer(initialState, {
  [events.cancelJobRequested]: setRequestStateToPending,
  [events.cancelJobSucceeded]: setRequestStateToSuccess,
  [events.cancelJobFailed]: setRequestStateToFailure,
});

function createSelector(getState: () => State): Selector {
  return {
    isCancelJobRequestFailure() {
      return getState().isFailure;
    },
    isCancelJobRequestPending() {
      return getState().isPending;
    },
    isCancelJobRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
